module.exports = __webpack_public_path__ + "img/124.b13d3c0a.jpg";